import React, { useEffect } from 'react'
import { useNavigation } from '@react-navigation/native'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { Feature, useFeatureFlag } from '@components'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Storage } from '@utils'
import { AccountAvatarNavigationBar } from '@src/components/navigationBar/AccountAvatarNavigationBar'
import { userSelector } from '@src/selectors/app'
import { useIntercomMessageNavigationAccessory } from '@src/hooks/useIntercomMessageNavigationAccessory'
import { useRefreshNotificationsOnFocus } from '@src/hooks/useRefreshNotificationsOnFocus'
import { useAllMemberNotes } from '@screens/NutritionistHub'
import { useSecureScreen } from '@src/hooks/useSecureScreen'
import { EhrNutritionistHubScreen } from '../components/EhrNutritionistHubScreen'

export const NutritionistHubContainer = () => {
  useSecureScreen()

  const navigation = useNavigation()
  const styles = useStyleSheet(themedStyle)
  const user = useSelector(userSelector)

  useRefreshNotificationsOnFocus()
  useAllMemberNotes()
  const intercomNavigationAccessory = useIntercomMessageNavigationAccessory({
    source: 'NutritionistHub',
  })
  const rightAccessories = [...intercomNavigationAccessory]

  const showCoachRatingModal =
    useFeatureFlag(Feature.CoachRating) &&
    user?.lastOccurredCoachingAppointment &&
    !user.lastOccurredCoachingAppointment.coachRating &&
    user.lastOccurredCoachingAppointment.providers[0]?.coach &&
    moment(user.lastOccurredCoachingAppointment.lastState.createdAt).diff(new Date()) < 14 &&
    !Storage.get(`${Storage.COACH_RATING_DISMISSED_KEY}_${user.lastOccurredCoachingAppointment.id}`)

  useEffect(() => {
    if (showCoachRatingModal) {
      navigation.navigate('RateCoachModal', {
        appointmentId: user.lastOccurredCoachingAppointment?.id,
      })
    }
  }, [navigation, showCoachRatingModal, user?.lastOccurredCoachingAppointment?.id])

  return (
    <AccountAvatarNavigationBar
      title="Care Team"
      rightAccessories={rightAccessories}
      style={styles.container}
    >
      <EhrNutritionistHubScreen />
    </AccountAvatarNavigationBar>
  )
}

const themedStyle = StyleService.create({
  container: {
    backgroundColor: 'theme.background',
  },
})
